"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _autoBind = _interopRequireDefault(require("auto-bind"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PacketBrokerAgent = /*#__PURE__*/function () {
  function PacketBrokerAgent(service) {
    (0, _classCallCheck2["default"])(this, PacketBrokerAgent);
    this._api = service;
    (0, _autoBind["default"])(this);
  }

  (0, _createClass2["default"])(PacketBrokerAgent, [{
    key: "_emitDefault",
    value: function _emitDefault(idObject) {
      if (!('net_id' in idObject)) {
        return _objectSpread(_objectSpread({}, idObject), {}, {
          net_id: 0
        });
      }

      return idObject;
    }
  }, {
    key: "_emitDefaults",
    value: function _emitDefaults(iterable) {
      var _iterator = _createForOfIteratorHelper(iterable),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var probe = _step.value;

          if ('id' in probe) {
            probe.id = this._emitDefault(probe.id);
          } else {
            if ('forwarder_id' in probe) {
              probe.forwarder_id = this._emitDefault(probe.forwarder_id);
            }

            if ('home_network_id' in probe) {
              probe.home_network_id = this._emitDefault(probe.home_network_id);
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return iterable;
    }
  }, {
    key: "getInfo",
    value: function () {
      var _getInfo = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GetInfo();

              case 2:
                result = _context.sent;
                return _context.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getInfo() {
        return _getInfo.apply(this, arguments);
      }

      return getInfo;
    }()
  }, {
    key: "register",
    value: function () {
      var _register = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(registration) {
        var result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._api.Register(undefined, registration);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function register(_x) {
        return _register.apply(this, arguments);
      }

      return register;
    }()
  }, {
    key: "deregister",
    value: function () {
      var _deregister = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var result;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.Deregister();

              case 2:
                result = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deregister() {
        return _deregister.apply(this, arguments);
      }

      return deregister;
    }()
  }, {
    key: "getHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _getHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var result;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._api.GetHomeNetworkDefaultRoutingPolicy();

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getHomeNetworkDefaultRoutingPolicy() {
        return _getHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return getHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "setHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _setHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(policy) {
        var result;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._api.SetHomeNetworkDefaultRoutingPolicy(undefined, policy);

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function setHomeNetworkDefaultRoutingPolicy(_x2) {
        return _setHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return setHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "deleteHomeNetworkDefaultRoutingPolicy",
    value: function () {
      var _deleteHomeNetworkDefaultRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        var result;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.DeleteHomeNetworkDefaultRoutingPolicy();

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteHomeNetworkDefaultRoutingPolicy() {
        return _deleteHomeNetworkDefaultRoutingPolicy.apply(this, arguments);
      }

      return deleteHomeNetworkDefaultRoutingPolicy;
    }()
  }, {
    key: "getHomeNetworkRoutingPolicy",
    value: function () {
      var _getHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(netId, tenantId) {
        var result;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GetHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    net_id: netId
                  }, tenantId ? {
                    tenant_id: tenantId
                  } : {})
                });

              case 2:
                result = _context7.sent;
                return _context7.abrupt("return", this._emitDefault(_marshaler["default"].payloadSingleResponse(result)));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getHomeNetworkRoutingPolicy(_x3, _x4) {
        return _getHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return getHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "setHomeNetworkRoutingPolicy",
    value: function () {
      var _setHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(netId, tenantId, policy) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.SetHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    'home_network_id.net_id': netId
                  }, tenantId ? {
                    'home_network_id.tenant_id': tenantId
                  } : {})
                }, policy);

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setHomeNetworkRoutingPolicy(_x5, _x6, _x7) {
        return _setHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return setHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "deleteHomeNetworkRoutingPolicy",
    value: function () {
      var _deleteHomeNetworkRoutingPolicy = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(netId, tenantId) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.DeleteHomeNetworkRoutingPolicy({
                  routeParams: _objectSpread({
                    net_id: netId
                  }, tenantId ? {
                    tenant_id: tenantId
                  } : {})
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].payloadSingleResponse(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function deleteHomeNetworkRoutingPolicy(_x8, _x9) {
        return _deleteHomeNetworkRoutingPolicy.apply(this, arguments);
      }

      return deleteHomeNetworkRoutingPolicy;
    }()
  }, {
    key: "listHomeNetworkRoutingPolicies",
    value: function () {
      var _listHomeNetworkRoutingPolicies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this._api.ListHomeNetworkRoutingPolicies(undefined, params);

              case 2:
                result = _context10.sent;
                response = _marshaler["default"].unwrapPacketBrokerPolicies(result);
                response.policies = this._emitDefaults(response.policies);
                return _context10.abrupt("return", response);

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function listHomeNetworkRoutingPolicies(_x10) {
        return _listHomeNetworkRoutingPolicies.apply(this, arguments);
      }

      return listHomeNetworkRoutingPolicies;
    }()
  }, {
    key: "listNetworks",
    value: function () {
      var _listNetworks = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this._api.ListNetworks(undefined, params);

              case 2:
                result = _context11.sent;
                response = _marshaler["default"].unwrapPacketBrokerNetworks(result);
                response.networks = this._emitDefaults(response.networks);
                return _context11.abrupt("return", response);

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function listNetworks(_x11) {
        return _listNetworks.apply(this, arguments);
      }

      return listNetworks;
    }()
  }, {
    key: "listForwarderRoutingPolicies",
    value: function () {
      var _listForwarderRoutingPolicies = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(params) {
        var result, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._api.ListForwarderRoutingPolicies(undefined, params);

              case 2:
                result = _context12.sent;
                response = _marshaler["default"].unwrapPacketBrokerPolicies(result);
                response.policies = this._emitDefaults(response.policies);
                return _context12.abrupt("return", response);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function listForwarderRoutingPolicies(_x12) {
        return _listForwarderRoutingPolicies.apply(this, arguments);
      }

      return listForwarderRoutingPolicies;
    }()
  }]);
  return PacketBrokerAgent;
}();

var _default = PacketBrokerAgent;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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